import React from 'react';
import { ReactComponent as CheckIcon } from '../../assets/icons/svg/shared/ic-shared-checkmark.svg';
import Heading from '../../generic-components/Heading';

export interface LiliRadioChipProps<T> {
  checked?: boolean;
  onClick?: (value: T) => void;
  radioGroupId?: string;
  value: T;
  label?: string;
  icon?: string;
  description?: string;
}
export const LiliRadioChip = (props: LiliRadioChipProps<any>) => {
  const { radioGroupId, onClick, checked, value, label, icon, description } = props;

  const getCheckedWrapperStyle = () => {
    if (checked) {
      return 'border border-action03';
    }
    return 'border border-bw04 hover:border-action03';
  };

  const getCheckedStyle = () => {
    if (checked) {
      return 'bg-action03 border border-action03';
    }
    return 'bg-bw00 border border-bw06 hover:border-action03';
  };

  return (
    <button
      onClick={() => onClick && onClick(value)}
      type='button'
      id={value.toString()}
      className={`${getCheckedWrapperStyle()} transition ease-in flex items-center gap-[6px] ${icon ? 'rounded-[8px] py-[8px] px-[16px] justify-start w-full' : 'rounded-[33px] justify-center py-[6px] px-[12px] w-fit'}  cursor-pointer hover:shadow-light`}
    >
      <div className='relative flex flex-col items-center'>
        <input
          className={`${getCheckedStyle()} w-[18px] h-[18px] transition ease-in rounded-[50%] appearance-none cursor-pointer`}
          type='radio'
          name={radioGroupId}
          checked={checked}
          value={value}
          id={value.toString()}
          onClick={() => onClick && onClick(value)}
        />
        <CheckIcon className='pointer-events-none stroke-bw01 w-[90%] text-bw00 absolute left-1/2 -translate-x-1/2 -top-1/2 translate-y-[calc(50%-8%)]' />
      </div>

      {label && (
        <div className={`flex flex-col items-baseline ${icon ? 'ml-[16px]' : ''} `}>
          <div className='flex items-center gap-[4px]'>
            {icon && <img alt='icon' src={icon} />}
            <label
              className='font-metricR pointer-events-none text-[16px] leading-[24px] text-bw08'
              htmlFor={value.toString()}
            >
              {label}
            </label>
          </div>
          {description && (
            <Heading title={description} className='font-metricR pointer-events-none text-[14px] text-bw07' />
          )}
        </div>
      )}
    </button>
  );
};
